import i18n from '../../i18n';
import actionTypes from '../constants/action-types';
import site from '../../site';

import actions from '../actions';

const metaTranslationsLoader = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.LOAD_META_TRANSLATIONS: {
      const locale = i18n.accessors.getLocale();

      site.helpers
        .fetchAsset(`ws/locale/${locale}.json`)
        .then(({ data }) => {
          store.dispatch(actions.setMetaTranslations(data));
        })
        .catch(() => {
          site.helpers
            .fetchAsset(`ws/locale/${i18n.constants.DEFAULT_LOCALE}.json`)
            .then(({ data }) => {
              store.dispatch(actions.setMetaTranslations(data));
            })
            .catch(() => next(action));
        });

      next(action);
      break;
    }
    default:
      next(action);
  }
};
export default metaTranslationsLoader;
